 import { authenticatedFetch } from "../Auth/Auth";
 import { getCurrentConfig } from '../../config/config';
 
 const config = getCurrentConfig();



export const postOFIAttendee = async (JSONbody, openTimeID) => {

    
     const response = await authenticatedFetch(`${config.API_BASE_URL}/attendeesOpenHome/${openTimeID}`, {
         method: 'POST',
           headers: {
            
            'Content-Type': 'application/json',
            'User-Agent': 'agentApp/1.0',
          },
         body: JSON.stringify(JSONbody),
       });
       if (response.ok) {
        return response.status;
      } else {
        throw new Error(`Error adding attendee`);
       }
};


export const postOFIOfflineAttendee = async (offlineJSONbody) => {
   
 
    const response = await authenticatedFetch(`${config.API_BASE_URL}/offlineAttendees`, {
        method: 'POST',
        headers: {
        
          'Content-Type': 'application/json',
          'User-Agent': 'agentApp/1.0',
        },
        body: JSON.stringify(offlineJSONbody)
      });
      
      if (response.ok) {
        const responseData = await response.json();
        return responseData;
      } else {
        throw new Error(`Error adding attendee offline`);
      }




};